export const CONFIG_CONST = {
    'DEFAULT_SERVER_HOST': 'conference.wildix.com',
    'HOSTS_DOMAIN': 'conference-xmpp.wildix.com'
};
